"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var material_1 = require("@mui/material");
var ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
var themes_1 = require("./themes");
var ConfigCard = __importStar(require("./A_ConfigProductCard"));
var theme = (0, themes_1.getTheme)();
/**
 * Used as a divider card in Config Card group, it shares the same height as the config card on mobile layout
 * but on desktop it takes up two columns and has a set height
 */
var Component = function (p) { return (Preact.h(Box_1.default, { sx: {
        height: { xs: ConfigCard.cardHeight, md: '45px' },
        width: { xs: '142px', md: '100%' },
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: { xs: 'space-between', md: 'center' },
        alignItems: 'flex-start',
        padding: '12px',
        paddingLeft: { md: '0px' },
        boxSizing: 'border-box',
        borderRadius: '8px',
        flexShrink: '0',
    } },
    Preact.h(Typography_1.default, { variant: "h5" }, p.helperText),
    (0, material_1.useMediaQuery)(theme.breakpoints.down('md')) && (Preact.h(Box_1.default, { sx: { display: 'flex', justifyContent: 'flex-end', width: '100%' } },
        Preact.h(ArrowForward_1.default, { color: "primary" }))))); };
exports.Component = Component;
